import { Stack, Typography } from '@mui/joy';
import type { ReactElement, ReactNode } from 'react';

export const PortfolioDefTile = ({
  name,
  children,
  dropdown,
}: {
  name: ReactNode;
  children?: ReactNode;
  dropdown?: ReactNode;
}): ReactElement => {
  return (
    <Stack direction="column" justifyContent="space-between" height="100%" gap={1}>
      <Stack justifyContent="space-between" direction="row">
        <Typography level="title-lg" component="h3">
          {name}
        </Typography>
        {dropdown}
      </Stack>
      {children}
    </Stack>
  );
};
